import { Injector } from '@angular/core';
import {
  ActionButtonOutcomesType,
  BaseWidgetProperties,
  ButtonActionType,
  SpendingBudgetRequest,
} from '@finxone-platform/shared/sys-config-types';
import { FormID } from '@finxone-platform/form-action';
import { Store } from '@ngxs/store';
import { take } from 'rxjs';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';
import { WorkflowFormsService } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-forms.service';
import { handleRedirection } from '../cta-redirection.utils';

export const saveSpendingBudgetValues = (widgetProperties: BaseWidgetProperties, injector: Injector) => {
  const workflowFormsService = injector.get(WorkflowFormsService);
  const accountService = injector.get(AccountService);
  const store = injector.get(Store);
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);

  const formValue = workflowFormsService.getFormValuesFlattened(FormID.SPENDING_BUDGET_FORM);
  const selectedAccountId = store.selectSnapshot(AccountState.getCurrentAccountId);

  if (!selectedAccountId) {
    console.error('No account selected');
    return;
  }

  accountService
    .upsertSpendingBudget({
      accountId: selectedAccountId,
      monthlyLimit: formValue.limit,
      resetDay: formValue.resetDay,
      isActive: formValue.isActive,
    } as SpendingBudgetRequest)
    .pipe(take(1))
    .subscribe({
      next: () => {
        ctaButtonSignalService.setSignal({ [ButtonActionType.SAVE_SPENDING_BUDGET]: false });
        handleRedirection(
          widgetProperties,
          injector,
          ActionButtonOutcomesType.SUCCESS,
          true,
          false,
          ButtonActionType.SAVE_SPENDING_BUDGET,
        );
      },
      error: () => {
        handleRedirection(
          widgetProperties,
          injector,
          ActionButtonOutcomesType.FAILURE,
          true,
          false,
          ButtonActionType.SAVE_SPENDING_BUDGET,
        );
      },
    });
};
